import React, {useState} from "react"
import classNames from "classnames"
import Icon from "../../components/Icon/Icon"

interface Props {
	title?: string
	children: React.ReactNode
	className?: string
	backgroundClassName?: string
	withShadow?: boolean
	collapsible?: boolean
	collapsedText?: string
	defaultExpanded?: boolean
}

export function ManagedSolutionsCard({
	title,
	children,
	className,
	backgroundClassName,
	withShadow,
	collapsible,
	collapsedText,
	defaultExpanded,
}: Props) {
	const [isExpanded, setIsExpanded] = useState(defaultExpanded ?? false)

	return (
		<div
			className={classNames(
				"managed-solutions-card",
				className,
				withShadow && "with-shadow",
				!isExpanded && "collapsed"
			)}
		>
			{backgroundClassName && <div className={classNames("managed-solutions-card-bg-base", backgroundClassName)} />}
			{title && (
				<div className="managed-solutions-card-title-container">
					<h2 className="managed-solutions-card-title">{title}</h2>
					{collapsible && (
						<button
							className="managed-solutions-card-collapse-container"
							onClick={() => setIsExpanded((prev) => !prev)}
						>
							{collapsedText && !isExpanded && (
								<span className="managed-solutions-card-collapsed-text">{collapsedText}</span>
							)}
							<Icon className="icon" icon="arrow-down-chevron" size={16} />
						</button>
					)}
				</div>
			)}
			{(isExpanded || !collapsible) && <div className="managed-solutions-card-content">{children}</div>}
		</div>
	)
}
